import React from 'react'
import { Row, Col, Typography } from 'antd'
import { HeaderHero, SEO } from './components'
import FAQAutoDamage from './FAQAutoDamage'
import FAQMedical from './FAQMedical'

import ClaimsStyle from '../../styles/ClaimsCenter.module.css'

const tabletImage = 'hero/claims/Claims_1024x300-no-copy.jpg'
const desktopImage = 'hero/claims/Claims_1440x300-no-copy.jpg'
const largeScreenImage = 'hero/claims/Claims_1620x300-no-copy.jpg'
const xtraLargeScreenImage = 'hero/claims/Claims_1960x300-no-copy.jpg'
const smallImage = 'hero/claims/Claims_375x188.jpg'
const smallImage390 = 'hero/claims/Claims_390x188.jpg'
const mobileImage = 'hero/claims/Claims_428x188.jpg'
const mobileImage768 = 'hero/claims/Claims_768x300-no-copy.jpg'

const { Text } = Typography

const ClaimsCenter = () => {
  return (
    <>
      <SEO
        description="CURE Auto Insurance provides claims support 24/7 for NJ, PA & MI drivers. Contact our CURE Claims Representative."
        title="Report A Claim 24/7 | CURE Auto Insurance"
        url="/claims"
      />
      <HeaderHero
        desktopImage={desktopImage}
        largeScreenImage={largeScreenImage}
        mobileImage={mobileImage}
        mobileImage768={mobileImage768}
        smallImage={smallImage}
        smallImage390={smallImage390}
        tabletImage={tabletImage}
        title="CLAIMS CENTER"
        xtraLargeScreenImage={xtraLargeScreenImage}
        alt={"Claims process - CURE auto insurance"}
      />
      <div className={`${ClaimsStyle["claim-center-screen"]} page-text-margin`}>
        <Row>
          <Text className={`${ClaimsStyle["claim-center-subtitle"]} ${ClaimsStyle["margin-top-0"]}`}>FREQUENTLY ASKED QUESTIONS AND RESOURCES</Text>
          <Text className={`${ClaimsStyle["claim-center-text-below-title"]}`}>
            Accidents can be stressful. Be assured your CURE claims representative will be available throughout the
            entire process to answer questions and work with you to handle the claim as quickly as possible.
          </Text>
          <Col xl={{ span: 12 }} xs={{ span: 24 }}>
            <section className={`${ClaimsStyle["section-auto"]}`}>
              <div>
                <Text className={`${ClaimsStyle["faq-subtitle"]}`}>AUTO/PROPERTY DAMAGE</Text>
              </div>
              <FAQAutoDamage />
            </section>
          </Col>
          <Col xl={{ span: 12 }} xs={{ span: 24 }}>
            <section>
              <div>
                <Text className={`${ClaimsStyle["faq-subtitle"]}`}>MEDICAL</Text>
              </div>
              <FAQMedical />
            </section>
          </Col>
        </Row>
      </div>
    </>
  )
}

ClaimsCenter.propTypes = {}

export default ClaimsCenter
